import { InvestmentIncome, Person, ScenarioSettings } from "src/types";
import {
  adjustCompoundInterest,
  adjustForIncrease,
  adjustForInflation,
} from "./utils";

import { CalculationInfo } from "./types";
import { startEndToYear } from "src/components/Info/StartEndSelect";

export const calculate = (info: CalculationInfo<InvestmentIncome>) => {
  const currentYear = info.currentYear;
  const { income } = info;

  const startYear =
    startEndToYear(income.start, info.people, info.scenario) ||
    new Date().getFullYear();
  const endYear = startEndToYear(income.end, info.people, info.scenario);
  if (currentYear < startYear || currentYear > endYear) {
    return 0;
  }

  let amount = 0;
  if (income.principalType === "Manual") {
    amount = ((income.principal || 0) * (income.withdrawalRate || 0)) / 100;
  } else if (income.principalType === "Calculated") {
    const startTime = performance.now();

    const schedule = calculateInvestmentSchedule(
      info.scenario,
      income,
      info.people,
      startYear,
    );
    const endTime = performance.now();
    console.log(
      `Investment income schedule calculated in ${endTime - startTime} ms`,
    );
    const year = currentYear - info.scenario.startYear;
    if (year < 0 || year >= schedule.length) {
      return 0;
    }
    const item = schedule.find((i) => i.year === startYear);
    if (item) {
      amount = (item.endAmount * (income.withdrawalRate || 0)) / 100;
    }
  }

  amount = adjustForIncrease(info, amount, Math.max(startYear));

  amount = adjustForInflation(info, amount, Math.max(startYear));

  return amount;
};

export const calculateInvestmentSchedule = (
  settings: ScenarioSettings,
  income: InvestmentIncome,
  people: Person[],
  startYear: number,
) => {
  let results = [] as any[];
  for (let i = new Date().getFullYear(); i <= startYear; i++) {
    let newInvestment = 0;

    for (let invest of income.schedule) {
      let startYear = startEndToYear(invest.start, people, settings) | 2025;
      let endYear = startEndToYear(invest.end, people, settings);
      if (i >= startYear && i <= endYear) {
        let amount = invest.amount as any;
        newInvestment += adjustCompoundInterest(
          amount,
          i - startYear,
          invest.yearlyIncrease,
        );
      }
    }
    newInvestment = Math.round(newInvestment * 100) / 100;

    let endAmount =
      (results[results.length - 1]?.endAmount || income.principal) +
      newInvestment;
    let returrn = (endAmount * (income.scheduleIncrease || 0)) / 100;
    returrn = Math.round(returrn * 100) / 100;

    results.push({
      year: i,
      newInvestment,
      endAmount: endAmount + returrn,
      return: returrn,
    });
  }
  return results;
};

export const calculateInvestmentIncome = (
  info: CalculationInfo<InvestmentIncome>,
) => {
  return { amount: calculate(info), note: "" };
};
